import { toast } from "@zerodevx/svelte-toast";

export const showToast = (message, isError = false, options) => {
  toast.push(message, {
    theme: {
      // Error toast - Red with enhanced glassmorphism
      "--toastBackground": isError
        ? "rgba(220, 38, 38, 0.9)"
        : "rgba(30, 15, 48, 0.9)", // Slightly more opaque for better readability
      "--toastBarBackground": isError
        ? "#b91c1c"
        : "var(--text-color1, #d2a552)", // Gold accent bar
      "--toastColor": "#ffffff",
      "--toastBorder": isError
        ? "1px solid rgba(220, 38, 38, 0.4)"
        : "1px solid rgba(210, 165, 82, 0.4)", // More visible border
      "--toastBoxShadow": isError
        ? "0 4px 20px rgba(220, 38, 38, 0.25), 0 1px 3px rgba(0, 0, 0, 0.3)"
        : "0 4px 20px rgba(210, 165, 82, 0.25), 0 1px 3px rgba(0, 0, 0, 0.3)",
      "--toastBorderRadius": "12px",
      "--toastPadding": "16px 20px",
      "--toastFontFamily": "'Heebo', sans-serif",
      "--toastFontSize": "14px",
      "--toastFontWeight": "500",
      "--toastLineHeight": "1.4",
      "--toastLetterSpacing": "0.01em",
      "--toastBackdropFilter": "blur(16px) saturate(180%)",
      "--toastMaxWidth": "400px",
      "--toastMinHeight": "60px",
    },
    duration: isError ? 6000 : 4000, // Longer duration for errors
    ...options,
  });
};

export const showSuccessToast = (message, options) => {
  // Custom success toast with green accent and enhanced styling
  toast.push(message, {
    theme: {
      "--toastBackground": "rgba(30, 15, 48, 0.9)",
      "--toastBarBackground": "#059669", // Darker green for better contrast
      "--toastColor": "#ffffff",
      "--toastBorder": "1px solid rgba(5, 150, 105, 0.4)",
      "--toastBoxShadow":
        "0 4px 20px rgba(5, 150, 105, 0.25), 0 1px 3px rgba(0, 0, 0, 0.3)",
      "--toastBorderRadius": "12px",
      "--toastPadding": "16px 20px",
      "--toastFontFamily": "'Heebo', sans-serif",
      "--toastFontSize": "14px",
      "--toastFontWeight": "500",
      "--toastLineHeight": "1.4",
      "--toastLetterSpacing": "0.01em",
      "--toastBackdropFilter": "blur(16px) saturate(180%)",
      "--toastMaxWidth": "400px",
      "--toastMinHeight": "60px",
    },
    duration: 4000,
    ...options,
  });
};

export const showErrorToast = (message, options) => {
  showToast(message, true, options);
};
